export const LAZYLOAD_IMAGE_ATTRIBUTE = 'data-src';
export const ORIGINAL_IMAGE_ATTRIBUTE = 'data-original-image';

export const LAZYLOAD_CLASS_NAME = 'lazyload';
export const LAZYLOADED_CLASS_NAME = 'lazyloaded';

export const BACKGROUND_IMAGE_CONTAINER_SELECTOR = '.js-container-with-background';
export const IMAGE_SELECTOR = 'img';
export const LAZYLOAD_VIDEO_ATTRIBUTE = 'data-src';
export const DEFAULT_MOBILE_BREAKPOINT = 960;
